import Vue from 'vue'
import VueI18n from 'vue-i18n'
import DefaultLocales from '../../locales/default_locales.json'
import FiltersLocales from '../../locales/default_filters.json'

Vue.use(VueI18n)

function loadLocaleMessages () {

  let locales , default_locales_filters ; 
  locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)

  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)

      // console.info("messages[locale]",messages[locale]) ; 

      if ( messages[locale].filters == undefined ){

        /*console.info({
          messages : messages ,
          FiltersLocales : FiltersLocales 
        }) ;*/ 
        messages[locale].filters = FiltersLocales.filters ; 
      }
    }
    // console.info("messages",messages) ; 
  })


  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  messages: loadLocaleMessages()
})
